import React from "react";
import { Check } from "lucide-react";
import LeadForm from "../components/LeadForm";
import { offer } from "../data";

export default function FinalCTA() {
  const benefits = [
    `Готовый зуб под ключ за ${offer.turnkeyFrom} ₽`,
    "Беспроцентная рассрочка до 24 месяцев",
    "Пожизненная гарантия на имплант",
    "Консультация и 3D-диагностика",
  ];

  return (
    <section className="final-cta" id="final">
      <div className="container">
        <div className="fc-wrap">
          <div>
            <h2 className="fc-title">
              Ваша <em>новая улыбка</em> — всего в одной заявке
            </h2>
            <p className="fc-sub">
              Не откладывайте решение. Получите безупречную улыбку и уверенность в себе уже в этом месяце. Запись ни к чему не обязывает.
            </p>

            <div className="fc-benefits">
              {benefits.map((b) => (
                <div key={b} className="fc-benefit">
                  <Check size={18} strokeWidth={2.5} />
                  <span>{b}</span>
                </div>
              ))}
            </div>
          </div>

          <LeadForm
            source="final_cta"
            title="Запишитесь на консультацию"
            subtitle="Куратор перезвонит в течение 15 минут и подберёт удобное время"
            buttonText="Записаться на приём"
          />
        </div>
      </div>
    </section>
  );
}
